import { render, staticRenderFns } from "./pip-reklass.vue?vue&type=template&id=d03166de"
import script from "./pip-reklass.vue?vue&type=script&lang=js"
export * from "./pip-reklass.vue?vue&type=script&lang=js"
import style0 from "./pip-reklass.vue?vue&type=style&index=0&id=d03166de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports